export var DocsBlockItemVariantLayoutGap;
(function (DocsBlockItemVariantLayoutGap) {
    /** small gap between columns/row */
    DocsBlockItemVariantLayoutGap["small"] = "Small";
    /** medium gap between columns/row */
    DocsBlockItemVariantLayoutGap["medium"] = "Medium";
    /** large gap between columns/row */
    DocsBlockItemVariantLayoutGap["large"] = "Large";
    /** no gap between columns/row */
    DocsBlockItemVariantLayoutGap["none"] = "None";
})(DocsBlockItemVariantLayoutGap || (DocsBlockItemVariantLayoutGap = {}));
